import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './routes/index.js'
import i18n from './i18n/index.js'
import * as Sentry from "@sentry/vue";

const pinia = createPinia()
const app = createApp(App)

Sentry.init({
    app,
    dsn: "https://253d8ee8c3bbe3c3388b560d0bd2db0b@o4507259719974912.ingest.de.sentry.io/4507259722072144",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/book\.balticexpo\.lv/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

app.use(pinia)
app.use(router)
app.use(i18n)

app.mount('#app')
